var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"export-files-page"}},[_c('ExportFilesTable',{staticClass:"mt-8",attrs:{"files":_vm.file_categories},on:{"on_generate_file_clicked":_vm.on_generate_file_clicked}}),(_vm.export_job)?_c('JobProgressInformation',{ref:"progress-popup",attrs:{"job_id":_vm.export_job.id},on:{"finished":_vm.job_finished}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }